import { ISelectOption } from '../../../../core/interfaces/select-option';

export class CostsControlSettings {

    static vatOptions: Array<ISelectOption> = [
        {value: 0, label: '0%'},
        {value: 'n/a', label: 'n/a'},
        {value: 0.135, label: '13.5%'},
        {value: 0.2, label: '20%'},
        {value: 0.21, label: '21%'},
        {value: 0.23, label: '23%'}
    ];

    static currencyOptions: Array<{value: string, label: string}> = [
        {value: 'GBP', label: '£'},
        {value: 'EUR', label: '€'},
        {value: 'USD', label: '$'}
    ];
}



// WEBPACK FOOTER //
// ./src/vas/controls/costs/form/costs-control.settings.ts